import React from 'react';
import { motion } from 'framer-motion';

const SucceedSection = () => {
  return (
    <section className="relative py-16 px-4 bg-[#F8FAFC] overflow-hidden">
      <div className="max-w-3xl mx-auto relative z-10">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Want to break into cloud engineering without quitting your current job?
          </h2>
          <p className="text-xl text-gray-600">
            We get it. You're busy with work, family, and life commitments. That's why we've designed a system that works for busy professionals like you.
          </p>
        </motion.div>

        <motion.div 
          className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-gray-100"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <div className="space-y-6">
            <p className="text-gray-700">
              Many aspiring cloud engineers face these challenges:
            </p>

            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start space-x-3">
                <span className="text-red-500">❌</span>
                <span>Overwhelmed by the vast amount of cloud services and technologies to learn</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-red-500">❌</span>
                <span>Struggling to find time to study while working full-time</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-red-500">❌</span>
                <span>Unsure which skills employers actually value and want to see</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-red-500">❌</span>
                <span>Lack of hands-on experience with real-world cloud projects</span>
              </li>
            </ul>

            <p className="font-medium text-gray-900 mt-8">
              Our system helps you overcome these challenges by providing:
            </p>

            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <span className="text-[#0EA5E9]">✅</span>
                <span>A structured learning path focused on the most in-demand cloud skills</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-[#0EA5E9]">✅</span>
                <span>Self-paced modules that fit around your schedule</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-[#0EA5E9]">✅</span>
                <span>Real-world projects that build your portfolio and practical experience</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-[#0EA5E9]">✅</span>
                <span>Expert guidance and support throughout your cloud journey</span>
              </li>
            </ul>

            <motion.button
              className="w-full bg-[#0EA5E9] text-white font-medium py-4 px-8 rounded-xl hover:bg-[#0284C7] transition-colors mt-6"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => {
                const pricingSection = document.querySelector('#pricing-section');
                if (pricingSection) {
                  pricingSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Start Your Cloud Journey Today
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SucceedSection; 